import React from 'react';
import PropTypes from 'prop-types';

function RouteStatusIcon({ route }) {
  const { totalStopsInProgress, status } = route;
  const statusClass = totalStopsInProgress ? 'STOPS_IN_PROGRESS' : status;

  const className = `routeMonitorRouteStatusIcon ${statusClass}`;

  return (
    <div data-testid={`${route.key}-status-icon`}>
      <div className={className} data-testid="status-icon-type" />
    </div>
  );
}

RouteStatusIcon.propTypes = {
  route: PropTypes.object.isRequired
};

export default RouteStatusIcon;
